module.exports = __webpack_public_path__ + "static/media/StartEvent.3e047e05.svg";